// extracted by mini-css-extract-plugin
export default {"div":"Header_div__myRiv","video":"Header_video__6PyvA","img":"Header_img__CL5dD"};